import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import OCFMultiStepForm from "./OCFMultiStepForm";
import Form from "./Form.jsx";
import MDBox from "components/MDBox";
const index = () => {
  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    //   {/* <div style={{ marginBottom: 100 }}>
    //     <div></div>
    //   </div> */}
    //   <Form />
    // </DashboardLayout>

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          height: "calc(90vh - 64px)", // subtract navbar height
          overflow: "hidden", // 🚨 stop DashboardLayout scroll
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Form />
      </MDBox>
    </DashboardLayout>
  );
};

export default index;
